import React, { useState } from 'react';
import { Lang } from './lib/i18n';
import { UrgencyBar } from './components/UrgencyBar';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { Services } from './components/Services';
import { Pricing } from './components/Pricing';
import { Value } from './components/Value';
import { Process } from './components/Process';
import { MockupForm } from './components/MockupForm';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { PrivacyModal, TermsModal } from './components/Modals';
export function App() {
  const [lang, setLang] = useState<Lang>('es');
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <div className="min-h-screen bg-white font-body text-brand-text-secondary selection:bg-brand-blue-primary/20 selection:text-brand-navy-dark" data-id="element-0">
      <UrgencyBar lang={lang} data-id="element-1" />
      <Nav lang={lang} setLang={setLang} data-id="element-2" />

      <main data-id="element-3">
        <Hero lang={lang} data-id="element-4" />
        <PainSection lang={lang} data-id="element-5" />
        <Services lang={lang} data-id="element-6" />
        <Pricing lang={lang} data-id="element-7" />
        <Value lang={lang} data-id="element-8" />
        <Process lang={lang} data-id="element-9" />
        <MockupForm openPrivacy={() => setIsPrivacyOpen(true)} openTerms={() => setIsTermsOpen(true)} data-id="element-10" />
        <Contact lang={lang} openPrivacy={() => setIsPrivacyOpen(true)} data-id="element-11" />
      </main>

      <Footer lang={lang} openPrivacy={() => setIsPrivacyOpen(true)} openTerms={() => setIsTermsOpen(true)} data-id="element-12" />

      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-13" />
      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-14" />
    </div>;
}